/**
 * Created by RKL on 07/09/2015.
 */
define('adminLmbSmpMatDetailsController',[
  'module',
  'underscore',
  'app',
  'bootbox',
  'adminLmbSmpMatDetailsView',
  'emptyView',
  'lmbSmpMatDetailTabController',
  'rolesMixin',
  'settings',
  'entities/lmbsmpmats'
], function(
  module,
  _,
  App,
  bootbox,
  View,
  EmptyView,
  lmbSmpMatDetailTabController
) {
  'use strict';

  var LmbSmpMatsDetailsController = {
    fetchLmbSmpMat: function(data) {
      var that = this,
          emptyView = new EmptyView(),
          contentRegion = App.regions.getRegion('main').currentView.getRegion('content');

      contentRegion.show(emptyView);

      this.data = data;
      if (this.model && this.model.get('secId') === data.secId) {
        this.showLmbSmpMat(data);
      } else {
        this.model = App.request('lmbsmpmat:model', {secId: data.secId});
        this.model.fetch().done(function() {
          if (contentRegion) {
            that.showLmbSmpMat(data);
          }
        });
      }
    },

    showLmbSmpMat: function(data) {
      var view = new View({model: this.model, data: data});

      this.view = view;
      data.model = this.model;

      App.regions.getRegion('main').currentView.getRegion('content').show(view);

      this.displayTabs(data);

      view.listenTo(view, 'click:tab', _.bind(this.onTabClick, this));
      view.listenTo(App, 'lmbsmpmat:header:rerender', _.bind(this.onHeaderChange, this));
    },

    onHeaderChange: function (lmbSmpMat) {
      this.view.onHeaderChange(lmbSmpMat);
    },

    displayTabs: function(data) {
      for (var region in this.view.regions) {
        if (App.regions.getRegion('main') && App.regions.getRegion('main').currentView &&
            App.regions.getRegion('main').currentView.getRegion('content') &&
            App.regions.getRegion('main').currentView.getRegion('content').currentView &&
            App.regions.getRegion('main').currentView.getRegion('content').currentView.getRegion(region)) {
          var currentViewRegion = App.regions.getRegion('main').currentView.getRegion('content').currentView.getRegion(region).currentView;
          if(currentViewRegion) {
            currentViewRegion.destroy();
          }
        }
      }

      lmbSmpMatDetailTabController.showTab(data);

      data.model = this.model;
      this.tab = data.tab;
    },

    onTabClick: function(tab) {
      if (this.data.tab !== tab || this.data.secId) {
        this.data.tab = tab;
        this.data.secId = null;

        this.displayTabs(this.data);
        App.navigate('admin/lmbsmpmats/' + this.model.get('secId') + '/' + tab.name);
      }
    }
  };

  module.exports = LmbSmpMatsDetailsController;
});
